import React from 'react';
import { cn } from './cn';

export const Empty = ({ title, children, className, icon }) => (
  <div
    className={cn(
      'flex flex-col items-center gap-2.5 rounded-card border border-dashed border-line-strong',
      'px-6 py-14 text-center text-ink-muted',
      className
    )}
  >
    {icon}
    {title && <p className="text-h5 text-ink">{title}</p>}
    {children}
  </div>
);

export default Empty;
